import React, { useEffect, useState } from 'react';
import styles from './VisitsReportWelcome.module.css';
import { ReactComponent as Klaviyo } from 'assets/icons/klaviyo.svg';
import { ReactComponent as Meta } from 'assets/icons/meta.svg';
import { DemoButtons } from '../DemoButtons/DemoButtons';
import { MapReport } from '../MapReport/MapReport';
import { ordinalSuffixOf } from '@mm/utils';
import visitsCRUDActions from '@mm/state/actions/VisitsCRUDActions';
import { useSelector } from 'react-redux';
import { StoreState } from '@mm/state/store-interfaces';

export const VisitsReportWelcome = ({ userVisits, isMobile }) => {
  const MAX_VISITS_LENGTH = 50;

  const [userName, setUserName] = useState('');

  const queryString = new URLSearchParams(window.location.search);
  const utmCampaign = queryString.get('utm_campaign');

  const visitorId = useSelector((state: StoreState) => state.visitor.visitorId);
  const visitsLength = userVisits.length;

  useEffect(() => {
    const userIdentity = (name, email) => {
      if (name && email) {
        return `${name} (${email})`;
      }
      return name || email || '';
    };

    const fetchUserInfo = async () => {
      if (!visitorId) {
        return;
      }

      const userInfo = await visitsCRUDActions.getUserInfo(
        visitorId,
        utmCampaign || '',
      );
      const { name, email } = userInfo;
      setUserName(userIdentity(name, email));
    };

    fetchUserInfo();
  }, [visitorId]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.hello}>
        <div className={styles.hello_section}>
          <h1 className={styles.hello_title}>
            <span>
              {visitsLength > 1 ? '👋' : '🎉'}Hi,{' '}
              {userName.length !== 0 && (
                <span className={styles.hello_title__email}>{userName}, </span>
              )}
              {visitsLength > 1
                ? 'nice to see you again!'
                : 'nice to meet you!'}{' '}
              This is
            </span>
            <span className={styles.hello_title__hightlight}>
              your{' '}
              {visitsLength === MAX_VISITS_LENGTH
                ? `${ordinalSuffixOf(visitsLength)} or more times`
                : `${ordinalSuffixOf(visitsLength)} time`}{' '}
              visiting
            </span>
            <span>our site.</span>
          </h1>
          <p className={styles.hello_description}>
            We can track and identify your website visitors to supercharge your
            ads and email marketing campaigns.
          </p>
        </div>
        <div className={styles.technology_section}>
          <p className={styles.technology_text}>Use this technology to:</p>
          <div className={styles.technology_item}>
            <Klaviyo alt="klaviyo" width={67} height={20} />
            <span>Supercharge your email marketing</span>
          </div>
          <div className={styles.technology_item}>
            <Meta alt="meta" width={67} height={20} />
            <span>Power your Facebook ads</span>
          </div>
        </div>
        <DemoButtons isMobile={isMobile} />
      </div>
      <MapReport visit={userVisits[0]} mode="vertical" isMobile={isMobile} />
    </div>
  );
};
